import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { useCurrentInstitution } from 'jotaiAtoms/currentInstitution';
import { useAppQuery } from 'services/reactQuery/useAppQuery';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { useAppMutation } from 'services/reactQuery/useAppMutation';
import { commonTexts, settingsTexts } from 'consts/text';
import { queryClient } from 'services/reactQuery/queryClient';
import { apiErrorCodes } from 'consts/api/apiErrorCodes';

type MealTypesPageNetworkManageParams = {
    onMealTypeRemoveRequestFinish: () => void;
};

export const useMealTypesPageNetworkManage = ({
    onMealTypeRemoveRequestFinish,
}: MealTypesPageNetworkManageParams) => {
    const currentInstitution = useCurrentInstitution();
    const { displaySuccess, displayError } = useSimpleNotification();

    const {
        data: mealTypesData,
        isInitialLoading: isMealTypesDataInitialLoading,
        isRefetching: isMealTypesDataRefetching,
        isError: isMealTypesDataError,
    } = useAppQuery('MEAL_TYPES', [], StaffHTTPService.mealTypes.getMealTypes, {});

    const { mutate: removeMealType, isLoading: isRemoveMealTypeLoading } = useAppMutation(
        StaffHTTPService.mealTypes.removeMealType,
        {
            key: ['MEAL_TYPES', currentInstitution.id],
            onSuccess: async (_, variables) => {
                onMealTypeRemoveRequestFinish();
                // variables is MealTypeId
                await queryClient.invalidateQueries([
                    currentInstitution.id,
                    'MEAL_TYPE',
                    variables,
                ]);
                displaySuccess(settingsTexts.mealTypes.successNotifications.mealTypeDeleted);
            },
            onError: (error) => {
                const code = (error.response?.data as { code: string })?.code;
                onMealTypeRemoveRequestFinish();
                if (code === apiErrorCodes.MEAL_TYPE_IN_USE_REMOVE_ATTEMPT) {
                    displayError(settingsTexts.mealTypes.errorsNotifications.mealTypeInUse);
                    return;
                }
                displayError(commonTexts.errorMessages.actionExecution);
            },
            invalidateQueryKeys: [['MEAL_TYPES']],
        },
    );

    return {
        mealTypesData,
        isMealTypesDataInitialLoading,
        isMealTypesDataRefetching,
        isMealTypesDataError,
        removeMealType,
        isRemoveMealTypeLoading,
    };
};
